import { render, staticRenderFns } from "./CriminalsEdit.vue?vue&type=template&id=318eabb4&"
import script from "./CriminalsEdit.vue?vue&type=script&lang=js&"
export * from "./CriminalsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports